export { default } from 'features/reward/routes/badge-detail-route';
